import {
  Breakpoint,
  Button,
  ButtonVariant,
  HorizontalFlex,
  MediumTextM,
  Modal,
  ModalSize,
  Space,
  VerticalFlex,
} from "@enxcs/dap-ui-stratos";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface WaitingModalProps {
  isOpen?: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  customTitle?: string;
  customCloseTitle?: string;
}

const WaitingModal: FC<WaitingModalProps> = ({
  isOpen,
  handleClose,
  handleConfirm,
  customTitle,
  customCloseTitle,
}) => {
  const { t } = useTranslation();
  return isOpen ? (
    <Modal
      size={ModalSize.M}
      title={customTitle || t("generatingPDFModal.title")}
      closeTitle={customCloseTitle || t("generatingPDFModal.close")}
      body={
        <VerticalFlex $gap={Space.V8} $justify="space-between" $align={"flex-start"}>
          <MediumTextM>{t("generatingPDFModal.message")}</MediumTextM>
        </VerticalFlex>
      }
      footer={
        <HorizontalFlex $gap={Space.V8} $justify="flex-end" $breakpoint={Breakpoint.S}>
          <Button
            variant={ButtonVariant.PRIMARY}
            label={t("generatingPDFModal.goBack")}
            onClick={() => {
              handleConfirm();
            }}
            disabled={false}
          />
        </HorizontalFlex>
      }
      onClose={() => {
        handleClose();
      }}
    />
  ) : null;
};

export default WaitingModal;
